"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isNotNil(value) {
    return value != null;
}
exports.isNotNil = isNotNil;
function getSelectedDeliveryOptions(order) {
    var deliveryOptions = order.deliveries.reduce(function (deliveryOptions, delivery) {
        if (delivery.discriminator === 'physical_delivery') {
            return deliveryOptions.concat(delivery.options);
        }
        return deliveryOptions;
    }, []);
    return order.selections.map(function (selection) {
        return deliveryOptions.find(function (deliveryOption) {
            return deliveryOption.id === selection;
        });
    }).filter(isNotNil);
}
exports.getSelectedDeliveryOptions = getSelectedDeliveryOptions;
function createProductsFromOrder(order, useBaseCurrency) {
    return order.items.map(function (item, index) {
        var line;
        var price;
        if (order.lines != null) {
            line = order.lines.find(function (_) { return _.item_number === item.number; });
        }
        if (useBaseCurrency) {
            if (line != null && line.price.base != null) {
                price = line.price.base.amount;
            }
        }
        else if (item.price != null) {
            price = item.price.amount;
        }
        // TODO: The most important thing about analytics is consistency in the data
        // but we cannot guarantee that because the cart page uses models that are
        // not available in the checkout pages.
        return {
            price: price,
            // TODO: No guarantee there is parity with cart item identifier.
            id: item.number,
            // TODO: No guarantee there is parity with cart item name.
            name: item.name,
            position: index,
            quantity: item.quantity,
        };
    });
}
exports.createProductsFromOrder = createProductsFromOrder;
function createProductFromItem(item, useBaseCurrency) {
    var itemPrice = item.price;
    if (useBaseCurrency && item.base_price != null) {
        itemPrice = item.base_price;
    }
    return {
        id: item.id,
        name: item.name,
        price: itemPrice,
        quantity: item.quantity,
        variant: item.variant,
    };
}
exports.createProductFromItem = createProductFromItem;
function getOrderShippingAmount(order, useBaseCurrency) {
    var shipping = order.prices.find(function (_) { return _.key === 'shipping'; });
    var shippingAmount = 0;
    if (shipping != null) {
        shippingAmount = useBaseCurrency ? shipping.base.amount : shipping.amount;
    }
    return shippingAmount;
}
exports.getOrderShippingAmount = getOrderShippingAmount;
function getOrderCurrency(order, useBaseCurrency) {
    return useBaseCurrency ? order.total.base.currency : order.total.currency;
}
exports.getOrderCurrency = getOrderCurrency;
function getOrderTaxAmount(order, useBaseCurrency) {
    var tax = order.prices.find(function (_) { return _.key === 'vat'; });
    var taxAmount = 0;
    if (tax != null) {
        taxAmount = useBaseCurrency ? tax.base.amount : tax.amount;
    }
    return taxAmount;
}
exports.getOrderTaxAmount = getOrderTaxAmount;
function getOrderDiscountCode(order) {
    var discountCode;
    if (order.attributes != null) {
        if (order.attributes.shopify_discount_code != null) {
            discountCode = order.attributes.shopify_discount_code;
        }
        else if (order.attributes.discount_code_label != null) {
            discountCode = order.attributes.discount_code_label;
        }
    }
    return discountCode;
}
exports.getOrderDiscountCode = getOrderDiscountCode;
function getExperimentKey(experiment) {
    if (experiment != null) {
        return experiment.key;
    }
    return undefined;
}
exports.getExperimentKey = getExperimentKey;
function getExperimentVariantKey(experiment) {
    if (experiment != null && experiment.variant != null) {
        return experiment.variant.key;
    }
    return undefined;
}
exports.getExperimentVariantKey = getExperimentVariantKey;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/utilities.js
// module id = 314
// module chunks = 0 1